module.exports = __webpack_public_path__ + "static/media/russiaMap.172df3a8.png";